/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @angular-eslint/no-input-rename */
import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { NgSelectConfig } from '@ng-select/ng-select';
import { LanguageService } from '../../services/parameters';

@Component({
  selector: 'app-dropdown-selector',
  templateUrl: './dropdown-selector.component.html',
  styleUrls: ['./dropdown-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownSelectorComponent),
      multi: true,
    },
  ],
})
export class DropdownSelectorComponent implements ControlValueAccessor {
  @Input() public label = 'Seleccione';
  @Input() public tooltipDescription = '';
  @Input() public placeholder: string;
  @Input('items') public set list(list: any[]) {
    this.items = this.flattenItems(list);
    if (this.clearOnFill) {
      this._value = null;
    }
  }
  @Input() public bindLabel: string;
  @Input() public bindValue: string;
  @Input() public requiredField: boolean;
  @Input() public searchable = false;
  @Input() public clearable = true;
  @Input() public isDisabled: boolean;
  @Input() public multiselect = false;
  @Input() public treeViewSelect = false;
  @Input() public image: string;
  @Input() public imagePosition: 'before' | 'after';
  @Input() public allSelectedOption: boolean;
  @Input() public closeOnSelect: boolean;
  @Input() public clearOnFill = true;

  public isControlDisabled: boolean;
  public value: string;
  public items: any[];

  public _onChange: any;
  public _onTouched: any;
  public _disabled: boolean;
  public _value: any;

  constructor(private config: NgSelectConfig, private languageService: LanguageService) {
    this.config.notFoundText = this.languageService.message('no-items-found');
    this.closeOnSelect = true;
  }

  /**
   * Flatten items to a single array with level property to indent items
   * @param items
   * @returns array of items with level property
   */
  flattenItems(items: any[]): any[] {
    const result = [];
    function recursiveFlatten(item, level = 0) {
      item.level = level;
      // if item has childs, it is disabled
      item.disabled = item.childs && item.childs.length > 0;
      result.push(item);
      if (item.childs && item.childs.length) {
        item.childs.forEach((child) => recursiveFlatten(child, level + 1));
      }
    }
    items.forEach((item) => recursiveFlatten(item));
    return result;
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  writeValue(obj: any): void {
    this._value = obj;
  }
}
